/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Device_CarInputs */

const en_why_listening_device_car = /** @type {(inputs: Why_Listening_Device_CarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In your car`)
};

const es_why_listening_device_car = /** @type {(inputs: Why_Listening_Device_CarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En el coche`)
};

/**
* | output |
* | --- |
* | "In your car" |
*
* @param {Why_Listening_Device_CarInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_device_car = /** @type {((inputs?: Why_Listening_Device_CarInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Device_CarInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_device_car(inputs)
	return en_why_listening_device_car(inputs)
});